import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import AgentStatusButton from './agent_status_button';
import AgentStatusTooltip from './agent_status_tooltip';
import connect from 'components/lib/connect';
import { EndpointTypes } from 'models/endpoint';
import Messaging from './icons/messaging';
import MessagingSelected from './icons/messaging_selected';
import registerHotkey from 'components/hotkeys/register_hotkey';
import RoutableCounts from 'models/routable_counts';
import { RoutingChannel, RoutingPreferenceGroup } from 'models/agent_routing_preferences';
import UpdateAgentRoutingPreferences from 'actions/routing/update_agent_routing_preferences';
import { useExecuteAction } from 'components/hooks/connect_hooks';
import useKeyboardShortcut from 'components/hooks/use_keyboard_shortcut';

const hotkey = registerHotkey({
  key: 'alt+3',
  group: 'Availability',
  label: 'Toggle readiness for messaging',
});

export function MessagingStatusButton({ channels, isLoading, isPreferred, routableCounts }) {
  const executeAction = useExecuteAction();
  const handleClick = useCallback(() => {
    executeAction(UpdateAgentRoutingPreferences, { [RoutingChannel.MESSAGING]: !isPreferred });
  }, [isPreferred]);
  useKeyboardShortcut(hotkey, handleClick);

  return (
    <div className={classnames('messagingStatusButton', { disabled: isLoading })}>
      <AgentStatusTooltip message={getTooltipText(channels)} preferenceGroup={RoutingPreferenceGroup.MESSAGING}>
        {({ isHovered }) => (
          <AgentStatusButton
            onClick={handleClick}
            preferenceGroup={RoutingPreferenceGroup.MESSAGING}
            routableCounts={routableCounts}
            showTrueCount={isHovered}
          >
            {isPreferred ? <MessagingSelected /> : <Messaging />}
          </AgentStatusButton>
        )}
      </AgentStatusTooltip>
    </div>
  );
}

MessagingStatusButton.propTypes = {
  channels: PropTypes.arrayOf(
    PropTypes.oneOf([
      EndpointTypes.CHAT,
      EndpointTypes.SMS,
      EndpointTypes.FB_MESSENGER,
      EndpointTypes.INSTAGRAM_DIRECT,
      EndpointTypes.WHATSAPP,
      EndpointTypes.TWITTER,
    ])
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isPreferred: PropTypes.bool.isRequired,
  routableCounts: PropTypes.instanceOf(RoutableCounts),
};

function getTooltipText(channels) {
  return channels.map(getChannelName).join(', ');
}

function getChannelName(channel) {
  switch (channel) {
    case EndpointTypes.CHAT:
      return 'Chat';
    case EndpointTypes.SMS:
      return 'SMS';
    case EndpointTypes.FB_MESSENGER:
      return 'FB Messenger';
    case EndpointTypes.INSTAGRAM_DIRECT:
      return 'Instagram Direct';
    case EndpointTypes.WHATSAPP:
      return 'WhatsApp';
    case EndpointTypes.TWITTER:
      return 'Twitter';
    default:
      return '';
  }
}

export default connect(mapStateToProps)(MessagingStatusButton);

function mapStateToProps({ getProvider, isFeatureEnabled }, { channels }) {
  const preferencesProvider = getProvider('agentRoutingPreferences');
  const preferences = preferencesProvider.getPending() || preferencesProvider.get();
  const isPreferred = preferences.isPreferredOnChannel(RoutingChannel.MESSAGING);
  const routableCounts = getProvider('routableCounts').get();

  let realtimeChannels = _.intersection(channels, [
    EndpointTypes.CHAT,
    EndpointTypes.FB_MESSENGER,
    EndpointTypes.INSTAGRAM_DIRECT,
    EndpointTypes.SMS,
    EndpointTypes.WHATSAPP,
    EndpointTypes.TWITTER,
  ]);

  return {
    channels: realtimeChannels,
    isLoading: preferences._version === 0,
    isPreferred,
    routableCounts,
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/page_layout/agent_status/messaging_status_button.jsx